import { Directive, forwardRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[validateDataError]',
    standalone: true,
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => ValidateDataErrorDirective),
            multi: true
        }
    ]
})
export class ValidateDataErrorDirective implements Validator, OnChanges {
    @Input()
    set validateDataError(value: ValidationErrors) {
        if (this._validateDataError !== value) {
            this._validateDataError = value;
        }
    }

    get validateDataError(): ValidationErrors | undefined {
        return this._validateDataError;
    }

    @Input()
    validateDataErrorKey?: string;

    private _validateDataError?: ValidationErrors;
    private _onChange?: () => void;

    ngOnChanges(changes: SimpleChanges) {
        if (changes['validateDataError']) {
            if (this._onChange) {
                this._onChange();
            }
        }
    }

    registerOnValidatorChange(fn: () => void): void {
        this._onChange = fn;
    }

    validate(control: AbstractControl): ValidationErrors | null {
        if (this.validateDataError && this.validateDataErrorKey && this.validateDataError[this.validateDataErrorKey]) {
            const _controlStatus = control.statusChanges.subscribe(() => {
                this._validateDataError = undefined;

                _controlStatus.unsubscribe();
            });

            return this.validateDataError;
        }

        return null;
    }
}
